// extracted by mini-css-extract-plugin
export default {"landing_container":"Landing_landing_container__EKmeH","landing_container_data":"Landing_landing_container_data__+9U1P"};